import IntroductionForm from './components/introduction_form'

window.Introductions = window.Introductions || {}
window.Introductions.New = window.Introductions.New || {}
window.Introductions.New = {
  IntroductionForm
}
